import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import Button from 'flarum/common/components/Button';
const SSO_URL = '/iceuniverse/sso/begin';
function startIceUniverseLogin() {
  window.location.assign(SSO_URL);
}
app.initializers.add('iceuniverse-sso', () => {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (app.session.user) return;
    items.remove('logIn');
    items.add('logIn', m(Button, {
      className: "Button Button--link",
      onclick: startIceUniverseLogin
    }, app.translator.trans('core.forum.header.log_in_link')), 0);
  });
  const originalNewDiscussionAction = IndexSidebar.prototype.newDiscussionAction;
  IndexSidebar.prototype.newDiscussionAction = function (...args) {
    if (!app.session.user) {
      startIceUniverseLogin();
      return Promise.reject();
    }
    return originalNewDiscussionAction.apply(this, args);
  };
});